import { useState } from "react";

import Modal from "ui-components/Modal";

import { useFetchDataFile } from "modules/data-files/api";
import { SelectSingleData } from "modules/data-files/elements/Data-File-Select";
import UploadFiles from "modules/data-files/elements/upload-files";

import { useInputFile } from "./store";

const SelectData = () => {
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [currentFile, setInputFile] = useInputFile();
  useFetchDataFile(currentFile, true);

  const label = (
    <div>
      <p>Select Data to Run the Analysis On:</p>
      <p className="font-normal text-sm text-gray-700">
        Cant find the data you want to select?{" "}
        <a
          className="underline text-primary-main cursor-pointer"
          onClick={() => setShowFileUpload(true)}
        >
          Click here to upload.
        </a>
      </p>
    </div>
  );

  return (
    <>
      <SelectSingleData
        label={label}
        selected={currentFile}
        onChange={setInputFile}
        name="select-input-data"
        enableTypeSelection
        enableDrop
      />
      <Modal
        show={showFileUpload}
        id="upload-files"
        handleClose={() => setShowFileUpload(false)}
      >
        <div className="m-2 p-2">
          <UploadFiles onComplete={() => setShowFileUpload(false)} />
        </div>
      </Modal>
    </>
  );
};

export default SelectData;
